<template>
  <div>
    <div class="foots" v-if="!$isMobile">
      <div class="foots-cl">
        <div class="foots-cl-p">
          <p>Follow Us</p>
        </div>
        <div class="foots-img-box">
          <div v-for="item in img" :key="item.name" class="img-cl">
            <div v-if="item.text">
              <span>
                {{ item.text }}
              </span>
            </div>
            <img v-else :src="item.src" alt="" />
          </div>
        </div>
        <div class="foots-bl-p">
          <p class="foots-p1">Copyright ©️ Ecosuper</p>
          <div class="foots-p2">
            <p>
              Conditions of Use/ / Privacy Statement/ / Cookie Settings /
              Imprint /
            </p>
            <p>Modern Slavery Act Statement</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="mobile-tab-bar">
        <div
          class="tab-item"
          v-for="(item, idx) in tabList"
          :key="idx"
          @click="$router.push(item.path)"
        >
          <div class="tab-icon">
            <img
              :src="currentTab === item.path ? item.activeImg : item.defaultImg"
              alt=""
            />
          </div>
          <div
            class="tab-text"
            :style="{ color: currentTab === item.path ? '#152535' : '#999' }"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: [
        {
          name: "facebook",
          text: "f",
        },
        {
          name: "twitter",
          src: require("../assets/img/f1.png"),
        },
        {
          name: "link1edin",
          text: "in",
        },
        {
          name: "link2edin",
          src: require("../assets/img/f2.png"),
        },
        {
          name: "link3edin",
          src: require("../assets/img/f3.png"),
        },
      ],
      currentTab: "/",
      tabList: [
        {
          label: "home",
          defaultImg: require("../assets/mo/home1.png"),
          activeImg: require("../assets/mo/home.png"),
          path: "/",
        },
        {
          label: "Laboratory",
          defaultImg: require("../assets/mo/Laboratory.png"),
          activeImg: require("../assets/mo/Laboratory1.png"),
          path: "/laboratory",
        },
        {
          label: "product",
          defaultImg: require("../assets/mo/product.png"),
          activeImg: require("../assets/mo/product1.png"),
          path: "/product",
        },
        {
          label: "attention",
          defaultImg: require("../assets/mo/attention.png"),
          activeImg: require("../assets/mo/attention1.png"),
          path: "/report",
        },
        // {
        //   label: "contact",
        //   defaultImg: require("../assets/mo/attention.png"),
        //   activeImg: require("../assets/mo/attention.png"),
        //   path: "/contact",
        // },
      ],
    };
  },
  watch: {
    $route(newVal) {
      // console.log(newVal);
      // 路由切换更新激活tab
      this.currentTab = newVal.path;
    },
  },
  mounted() {
    this.originHeight = document.documentElement.clientHeight;
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      const nowHeight = document.documentElement.clientHeight;
      const tab = document.querySelector(".mobile-tab-bar");
      // 可视高度变小 = 软键盘弹出
      if (!tab) return;
      if (nowHeight < this.originHeight - 120) {
        tab.style.display = "none";
      } else {
        tab.style.display = "flex";
      }
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.handleResize);
    },
  },
};
</script>

<style lang="scss" scoped>
.foots {
  width: 100%;
  padding: 0 0 8px 0;
  background: #152535;
  .foots-cl {
    display: flex;
    flex-direction: column;
    align-items: center;
    .foots-cl-p {
      color: #fff;
      font-size: 23px;
      margin-top: 44px;
    }
    .foots-img-box {
      display: flex;
      margin-top: 18px;
      .img-cl {
        width: 34px;
        height: 34px;
        background: #00a0e9;
        margin: 0 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          font-size: 26px;
          font-weight: 700;
          color: #fff;
        }
        img {
          width: 17px;
          height: 17px;
        }
      }
    }
    .foots-bl-p {
      border-top: 1px solid #ffffff;
      width: 925px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      font-size: 10px;
      margin-top: 51px;
      .foots-p1 {
        position: absolute;
        top: 24px;
        left: 7px;
      }
      .foots-p2 {
        text-align: center;
        margin-top: 14px;
      }
    }
  }
}

.mobile-tab-bar {
  width: 750rpx;
  height: 100rpx;
  background: #f7f7f7;
  display: flex;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  box-sizing: border-box;
  padding-top: 10rpx;
  .tab-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .tab-icon {
      width: 47rpx;
      height: 47rpx;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .tab-text {
      font-size: 22rpx;
      color: #333333;
    }
  }
}
</style>